import { render, staticRenderFns } from "./BaseExclamationMark.vue?vue&type=template&id=96d5e340&scoped=true&"
import script from "./BaseExclamationMark.vue?vue&type=script&lang=js&"
export * from "./BaseExclamationMark.vue?vue&type=script&lang=js&"
import style0 from "./BaseExclamationMark.vue?vue&type=style&index=0&id=96d5e340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5e340",
  null
  
)

export default component.exports